import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../Containers/Config/index.js';

import { GET_PERMISSION_CHECKER, GET_PERMISSION_CHECKER_SUCCESS, GET_PERMISSION_CHECKER_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getPermissionChecker({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/request`,
      method: 'GET',
      headers: {
        Authorization: payload?.token,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
        pageIndex: 0,
        pageSize: 1000,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_PERMISSION_CHECKER_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PERMISSION_CHECKER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PERMISSION_CHECKER_ERROR, payload: error });
  }
}

export function* watchPermissionChecker() {
  yield takeEvery(GET_PERMISSION_CHECKER, getPermissionChecker);
}

function* getPermissionCheckerSaga() {
  yield all([fork(watchPermissionChecker)]);
}

export default getPermissionCheckerSaga;
